// extracted by mini-css-extract-plugin
export default {"root":"BaseModal_root__FPP3K","header":"BaseModal_header__PxM7A","body":"BaseModal_body__Jxksv","closeButton":"BaseModal_closeButton__fg8Qz"};